export const mobileMenuToggle = 'OKENDO_MOBILE_MENU_TOGGLE';
export const videoLoaded = 'OKENDO_VIDEO_LOADED';
